exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".step-0[data-v-b9c61f7a]{position:relative}.wizard-close[data-v-b9c61f7a]{position:absolute;right:-15px;top:-15px;font-size:24px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-b9c61f7a","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/Step0.vue
// module id = 55
// module chunks = 0